import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MailFields } from './mailfields';
import { environment } from '../../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class MailFieldsService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;
  //httpclient get method
  Get(): Observable<MailFields[]> {
    return this.httpClient.get<MailFields[]>(this.baseUrl + 'api/MailFieldsApi/');
  }

  //httpclient post method
  Post(mailfieldmodel: MailFields): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/MailFieldsApi/add', mailfieldmodel,
      { headers: header, observe: 'response' });
  }
  //httpclient put method
  Put(mailfieldmodel: MailFields): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailFieldsApi/Update', mailfieldmodel,
      { headers: header, observe: 'response' });
  }
  //httpclient delete method
  Delete(mailfieldmodel: MailFields): Observable<any> {
    return this.httpClient.put<any>(this.baseUrl + 'api/MailFieldsApi/activeordeactive', mailfieldmodel, { headers: header, observe: 'response' })
  }




}
